export default [
  {
    title: "Какие ценности тебе близки?",
    model: "my_values",
    items: [
      {
        text: "Мне близко движение вперёд вместе с командой, когда каждый чувствует свой рост и причастность к общему смыслу",
        value: "tulpar",
      },
      {
        text: "Ставь цели и иди до конца. Каждый результат — старт для новой вершины",
        value: "ak_bars",
      },
      {
        text: "Главное - начать, остальное подтянется за действиями",
        value: "ak_bure",
      },
      {
        text: "Открытость ко всему новому и к людям",
        value: "samruh",
      },
      {
        text: "Принимать реальность и находить в ней свое удовольствие",
        value: "zilant",
      },
    ],
  },
  {
    title: "Что для тебя важнее всего, когда ты двигаешься к большой цели?",
    model: "big_goal",
    items: [
      {
        text: "Быть верным самому себе и верить, что ты делаешь это во благо",
        value: "zilant",
      },
      {
        text: "Чёткое видение результата и внутренняя уверенность: я не жду идеальных условий, а создаю их своими действиями",
        value: "ak_bars",
      },
      {
        text: "Делать это с огнем внутри, зажигая остальных , и получать удовольствие",
        value: "samruh",
      },
      {
        text: "Я ищу баланс между результатом и тем, как мы к нему идём. Если путь разрушает меня или команду — это не моя цель",
        value: "tulpar",
      },

      {
        text: "Всегда действовать, даже боясь, что не получится, и двигаться дальше и дальше",
        value: "ak_bure",
      },
    ],
  },
  {
    title: "Как ты относишься к своим сильным сторонам в командной работе?",
    model: "strengths",
    items: [
      {
        text: "Я дружелюбен и эмпатичен, пытаюсь понять каждого человека в команде",
        value: "zilant",
      },
      {
        text: "Проявляю их смело: инициатива, талант и несгибаемый характер — мой вклад в общую победу",
        value: "ak_bars",
      },
      {
        text: "Проявляю насколько возможно, больше с творческой стороны",
        value: "samruh",
      },
      {
        text: "Моя сила — видеть потенциал там, где другие видят проблему, и мягко направлять команду, чтобы каждый раскрылся",
        value: "tulpar",
      },

      {
        text: "Для меня важна команда, люди - моя сильная сторона, я всегда обменяюсь своим опытом с ними",
        value: "ak_bure",
      },
    ],
  },
  {
    title: "Какой формат работы тебе ближе всего?",
    model: "work_format",
    items: [
      {
        text: "Работать, когда есть ощущение пути и развития, а не просто задачи",
        value: "tulpar",
      },
      {
        text: "Ценю командную работу и поддержку",
        value: "ak_bure",
      },
      {
        text: "Главное, чтобы это было искренне",
        value: "zilant",
      },
      {
        text: "Работать командой, поддерживая и слушая каждого",
        value: "samruh",
      },
      {
        text: "Динамичный, с вызовами и пространством для инициативы. Где каждый день — шанс проявить характер",
        value: "ak_bars",
      },
    ],
  },
  {
    title: "Что для тебя «хороший результат»?",
    model: "good_result",
    items: [
      {
        text: "Когда получилось создать что-то, что вдохновляет и даёт людям новый взгляд",
        value: "tulpar",
      },
      {
        text: "Когда после всех провалов, ты продолжаешь идти",
        value: "zilant",
      },
      {
        text: "Когда после всего получилось заснуть со спокойной душой и приятной усталостью",
        value: "samruh",
      },
      {
        text: "Когда превзошли ожидания, а препятствие стало трамплином. После победы хочется брать новую высоту",
        value: "ak_bars",
      },
      {
        text: "Хороший результат — это когда я не побоялся рискнуть и у меня получилось",
        value: "ak_bure",
      },
    ],
  },
  {
    title: "Как ты любишь проводить свободное время?",
    model: "free_time",
    items: [
      {
        text: "Придумывать что-то новое и не сидеть на месте",
        value: "samruh",
      },
      {
        text: "Активно: спорт, новые навыки, челленджи, встречи с заряжающими людьми",
        value: "ak_bars",
      },
      {
        text: "Я люблю рефлексировать и задумываться о важном",
        value: "zilant",
      },
      {
        text: "Люблю активный отдых: спорт, прогулки, путешествия. Главное — чтобы было нескучно и в движении",
        value: "tulpar",
      },
      {
        text: "Проводить время с родными и близкими в спокойной обстановке",
        value: "ak_bure",
      },
    ],
  },
  {
    title: "Когда у меня нет сил двигаться дальше, я…",
    model: "no_strength",
    items: [
      {
        text: "Меняю тактику и переключаюсь на ту идею, которая прямо сейчас зажигает меня больше всего",
        value: "ak_bure",
      },
      {
        text: "Вспоминаю «зачем», ставлю микроцель и делаю шаг. Фокус на миссии возвращает силу",
        value: "ak_bars",
      },
      {
        text: "Постараюсь понять причину и вспомню ради чего я действую",
        value: "zilant",
      },
      {
        text: "Я найду эти силы в самовыражении и творчестве",
        value: "samruh",
      },
      {
        text: "Честно признаю себе: «Стоп. Сейчас я не могу». Позволяю себе отдохнуть, потому что настоящая сила — не в том, чтобы ломать себя, а в том, чтобы вовремя остановиться и вернуться с новым дыханием",
        value: "tulpar",
      },
    ],
  },
  {
    title: "Через 20 лет я вижу себя…",
    model: "my_future",
    items: [
      {
        text: "Лидером, который ломал стереотипы, вдохновлял других и оставлял след",
        value: "ak_bars",
      },
      {
        text: "Цель моего пути будет все время обновляться, и я не буду останавливаться",
        value: "zilant",
      },
      {
        text: "Там, где мне комфортно быть собой",
        value: "samruh",
      },
      {
        text: "Тем, кто не застрял на месте. Живым, счастливым и в движении и всё ещё в поиске интересного",
        value: "tulpar",
      },
      {
        text: "Я вижу себя абсолютно счастливым человеком, потому что всю жизнь быстро брал доступные возможности и делал то, что нравится",
        value: "ak_bure",
      },
    ],
  },
  {
    title: "В какой момент мне становится не комфортно?",
    model: "my_comfort",
    items: [
      {
        text: "Когда всё стоит на месте, повторяется и я чувствую, что топчусь без толку",
        value: "tulpar",
      },
      {
        text: "Я понимаю, что запутался и копирую других",
        value: "zilant",
      },
      {
        text: "Когда рядом нет единомышленников и вокруг серость и скука",
        value: "samruh",
      },
      {
        text: "Мне не комфортно, когда я один и делаю, что не нравится",
        value: "ak_bure",
      },
      {
        text: "Когда выбирают делать «как все»",
        value: "ak_bars",
      },
    ],
  },
  {
    title: "Что мне больше всего нравится в людях?",
    model: "like_in_people",
    items: [
      {
        text: "Их идентичность и широкий кругозор",
        value: "zilant",
      },
      {
        text: "Искренность и умение быть рядом в трудный момент. Когда человек не играет, а делает то, что говорит",
        value: "tulpar",
      },
      {
        text: "Мне нравится их умение объединяться ради общих целей",
        value: "ak_bure",
      },
      {
        text: "Искренность и заряд позитива, так же очень важно чувство юмора",
        value: "samruh",
      },
      {
        text: "Смелость быть собой, инициатива без разрешения и характер",
        value: "ak_bars",
      },
    ],
  },
];
